module.exports = __webpack_public_path__ + "img/edit.61927b47.svg";